/**
* 报告运行状态
*/
export const PREPARE_RUN = 0
export const RUNNING = 1
export const SUCCESS = 2
export const FAIL = 3

/**
* azf质检状态
*/
export const SUCCESS_QUALITY = 0
export const CONTROL_FAIL_QUALITY = 1
export const CASE_FAIL_QUALITY = 2



// WEBPACK FOOTER //
// ./src/app/utils/const.js